import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ data }) {
  useEffect(() => {
    document.title = `${data.title} | AJG M&A Consulting`;
    const d = document.querySelector('meta[name="description"]');
    if (d) d.setAttribute("content", data.metaDesc);
  }, [data]);

  return (
    <div className="min-h-screen">
      <header className="border-b border-gold/10">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-6">
          <Link to="/" data-testid="legal-logo">
            <img src="/logo-light.png" alt="AJG M&A Consulting" className="h-12 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="group flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.18em] text-slate-300 transition-colors hover:text-gold"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
            Volver al inicio
          </Link>
        </div>
      </header>

      <motion.main
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto max-w-4xl px-6 py-16 md:py-24"
        data-testid={`legal-page-${data.slug}`}
      >
        <p className="eyebrow">Documento legal</p>
        <h1 className="mt-6 font-serif text-4xl text-white sm:text-5xl">{data.title}</h1>
        <p className="mt-4 text-sm text-slate-500">Última actualización: octubre de 2026</p>
        {data.intro?.map((p, i) => (
          <p key={i} className="mt-5 text-sm leading-relaxed text-slate-300 md:text-base">
            {p}
          </p>
        ))}
        {data.sections.map((s, i) => (
          <section key={i} className="mt-12">
            <h2 className="font-serif text-2xl text-gold-light">{s.heading}</h2>
            {s.paragraphs.map((p, j) => (
              <p key={j} className="mt-4 text-sm leading-relaxed text-slate-300 md:text-base">
                {p}
              </p>
            ))}
          </section>
        ))}
      </motion.main>

      <footer className="border-t border-gold/10 py-8">
        <p className="mx-auto max-w-4xl px-6 text-xs tracking-wide text-slate-500">
          © 2026 AJG M&amp;A Consulting, S.L. Todos los derechos reservados.
        </p>
      </footer>
    </div>
  );
}
